<template>
    <div :class="{'app-container': true, 'is-client-page': isClientPage}">

        <AppHeader ref="siteHead"></AppHeader>
        <div id="scrollbarWrap" :class="{'app-wrap': true, 'scrollbar-wrap': true,}">
            <app-main ref="appMain"></app-main>
        </div>
      <div id="absoluteFooter" v-if="$route.path!=='/clientPage/detail'" :class="{'footer-container': true, 'absolute-footer': footerAbsolute,}">
        <AppFooter></AppFooter>
    </div>
      <privacy-notice-consent-dialog
        :visible="privacyConsentDialogVisible"
        :notice="(privacyConsentUserInfo && privacyConsentUserInfo.activePrivacyNotice) || {}"
        :submitting="privacyConsentSubmitting"
        @confirm="handlePrivacyConsentConfirm"
        @request-close="handlePrivacyConsentCloseAttempt"
      />
    </div>
</template>

<script>
import AppHeader from "./components/AppHeader.vue";
import AppFooter from "./components/AppFooter.vue";
import AppMain from "./components/AppMain.vue";
import EventConnect from "@/utils/event";
import { getUserInfo, getToken, setUserInfo } from "@/utils/auth";
import { getUserInfo as fetchUserInfo } from "@/api/login";
import PrivacyNoticeConsentDialog from '@/components/PrivacyNoticeConsentDialog.vue';
import privacyConsentMixin from '@/mixins/privacyConsentMixin';

export default {
    name: "HomeLayout",
    components: {
        AppHeader,
        AppMain,
        AppFooter,
        PrivacyNoticeConsentDialog
    },
  mixins: [privacyConsentMixin],
  watch: {
      '$route'() {
        this.scrollToTop();
        this.$nextTick(() => {
          this.initFooter();
          this.syncClientMobileClass();
          this.scrollToTop();
        });
        this.ensurePrivacyConsentFromServer();
      },
  },
  data() {
      return {
        footerAbsolute: false,
        privacyProfileRefreshing: false,
      }
  },
  computed: {
    isClientPage() {
      return (this.$route.path || '').indexOf('/clientPage') === 0;
    },
  },
  methods: {
      syncClientMobileClass() {
        const enabled = this.isClientPage && window.innerWidth <= 768;
        document.documentElement.classList.toggle('is-client-mobile', enabled);
        document.body.classList.toggle('is-client-mobile', enabled);
      },
      scrollToTop() {
        const scrollWrap = document.getElementById('scrollbarWrap');
        if (scrollWrap) {
          scrollWrap.scrollTop = 0;
        }
        window.scrollTo(0, 0);
        if (document.documentElement) {
          document.documentElement.scrollTop = 0;
        }
        if (document.body) {
          document.body.scrollTop = 0;
        }
      },
      initFooter() {
        const scrollWrap = document.getElementById('scrollbarWrap');
        if (!scrollWrap) {
          return;
        }
        const footer = document.getElementById('absoluteFooter');
        if (!footer) {
          // Detail page: use document flow so header can scroll out of view.
          scrollWrap.style.position = 'inherit';
          scrollWrap.style.top = '';
          scrollWrap.style.bottom = '';
          scrollWrap.style.paddingBottom = '0';
          return;
        }

        // Mobile client pages: natural document flow, no fixed min-width shell.
        if (this.isClientPage && window.innerWidth <= 768) {
          scrollWrap.style.position = 'inherit';
          scrollWrap.style.top = '';
          scrollWrap.style.bottom = '';
          scrollWrap.style.paddingBottom = '0';
          footer.style.position = 'inherit';
          footer.style.bottom = '';
          footer.style.left = '';
          return;
        }

        scrollWrap.style.position = 'absolute';
        scrollWrap.style.top = '';
        scrollWrap.style.bottom = '';
        scrollWrap.style.paddingBottom = '';
        const nodeHeight = scrollWrap.scrollHeight;
        const windowHeight = window.innerHeight;
        if ((nodeHeight + 216) < windowHeight) {
          footer.style.position = 'absolute';
          footer.style.bottom = '0';
          footer.style.left = '0';
        } else {
          scrollWrap.style.position = 'inherit';
          scrollWrap.style.paddingBottom = '120px';
          footer.style.position = 'inherit';
        }
      },
      async ensurePrivacyConsentFromServer() {
        if (!getToken() || this.privacyConsentDialogVisible || this.privacyConsentSubmitting || this.privacyProfileRefreshing) {
          return;
        }

        const cachedUserInfo = getUserInfo();
        if (cachedUserInfo && !this.isPrivacyConsentApplicable(cachedUserInfo)) {
          return;
        }
        if (cachedUserInfo && this.isPrivacyConsentRequired(cachedUserInfo)) {
          await this.maybeRequirePrivacyConsent(cachedUserInfo);
          return;
        }

        this.privacyProfileRefreshing = true;
        try {
          const res = await fetchUserInfo();
          const latestUserInfo = {
            ...res.data,
            originalRoles: (cachedUserInfo && cachedUserInfo.originalRoles) || res.data.roles,
            roles: (cachedUserInfo && cachedUserInfo.roles && cachedUserInfo.roles.length)
              ? cachedUserInfo.roles
              : res.data.roles,
          };
          setUserInfo(latestUserInfo);
          await this.maybeRequirePrivacyConsent(latestUserInfo);
        } catch (error) {
          console.log(error);
        } finally {
          this.privacyProfileRefreshing = false;
        }
      },
  },
    mounted() {
        let _self = this;
        EventConnect.$on('goTop',  ()=> {
            _self.scrollToTop();
        })
      _self.scrollToTop();
      _self.initFooter();
      _self.syncClientMobileClass();
      this.onResize = () => {
        this.initFooter();
        this.syncClientMobileClass();
      };
      window.addEventListener('resize', this.onResize);
      this.ensurePrivacyConsentFromServer();
      setTimeout(() => {
        this.initFooter();
        this.scrollToTop();
      }, 500);
    },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
    document.documentElement.classList.remove('is-client-mobile');
    document.body.classList.remove('is-client-mobile');
  },
}
</script>

<style scoped lang="less">
.app-container {
  position: relative;
  min-height: 100%;
  background-color: #F9FAFB;

    .scrollbar-wrap {
        min-width: 800px;
        position: absolute;
        top: 0;
        right: 0;
        bottom: 97px;
        left: 0;
        overflow: hidden;
        overflow-x: auto;
        overflow-y: auto;
    }
  .footer-container {
    height: 97px;
  }
  .absolute-footer {
    position: absolute;
    bottom: 0;
    left: 0;
  }

  &.is-client-page {
    .scrollbar-wrap {
      min-width: 0;
    }
  }
}

@media (max-width: 768px) {
  .app-container.is-client-page {
    min-height: 100vh;
    min-height: 100dvh;
    display: flex;
    flex-direction: column;
    background-color: #F9FAFB;

    .scrollbar-wrap {
      position: relative !important;
      top: auto !important;
      right: auto !important;
      bottom: auto !important;
      left: auto !important;
      min-width: 0;
      min-height: 0;
      flex: 1 0 auto;
      overflow-x: hidden;
    }
    .footer-container {
      height: auto;
      min-height: 0;
      margin-top: auto;
      background-color: #000;
      border: none;
      overflow: visible;
      padding-bottom: env(safe-area-inset-bottom, 0);
    }
  }
}
</style>
